import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { callback } from "../../../api/apiServices";
import AuthContext from "../../../context/AuthProvider";

const Callback = () => {
  const { auth } = useContext(AuthContext);
 
  let collectionStatus = (
     <></>
    );

  return (
    <>
      <section className="content-header">
        <h1>MoMo Transaction Status</h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-9">
                    <h4 className="panel-title">
                      <span> Callback Transactions</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="panel-body">{collectionStatus}</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Callback;
